/**
 * 检测是否为无痕浏览器模式
 * 在无痕模式下，localStorage 和 sessionStorage 的行为会有所不同
 */
export function isIncognitoMode() {
    return new Promise((resolve) => {
        // 方法1: 检测 localStorage 的配额
        try {
            const testKey = '__incognito_test__';
            localStorage.setItem(testKey, 'test');
            localStorage.removeItem(testKey);
            // 如果能正常存储和删除，说明不是无痕模式
            resolve(false);
        }
        catch (e) {
            // 如果出现异常，可能是无痕模式
            resolve(true);
        }
    });
}
/**
 * 检测是否为无痕浏览器模式（同步版本）
 * 使用更可靠的方法检测
 */
export function isIncognitoModeSync() {
    try {
        // 方法1: 检测 indexedDB 是否可用
        if (!window.indexedDB) {
            return true;
        }
        // 方法2: 检测 localStorage 配额
        const testKey = '__incognito_test__';
        localStorage.setItem(testKey, 'test');
        localStorage.removeItem(testKey);
        // 方法3: 检测 navigator.webdriver（某些自动化工具会设置此属性）
        if (navigator.webdriver) {
            return true;
        }
        // 方法4: 检测插件数量（无痕模式下插件数量通常为0）
        if (navigator.plugins && navigator.plugins.length === 0) {
            return true;
        }
        return false;
    }
    catch (e) {
        // 如果出现任何异常，认为是无痕模式
        return true;
    }
}
/**
 * 安全地使用 localStorage，在无痕模式下自动降级
 */
export class SafeStorage {
    constructor() {
        this.isIncognito = isIncognitoModeSync();
    }
    setItem(key, value) {
        if (this.isIncognito) {
            console.log('无痕模式检测到，跳过 localStorage 存储');
            return false;
        }
        try {
            localStorage.setItem(key, value);
            return true;
        }
        catch (e) {
            console.warn('localStorage 存储失败:', e);
            return false;
        }
    }
    getItem(key) {
        if (this.isIncognito) {
            console.log('无痕模式检测到，返回空值');
            return null;
        }
        try {
            return localStorage.getItem(key);
        }
        catch (e) {
            console.warn('localStorage 读取失败:', e);
            return null;
        }
    }
    removeItem(key) {
        if (this.isIncognito) {
            console.log('无痕模式检测到，跳过 localStorage 删除');
            return false;
        }
        try {
            localStorage.removeItem(key);
            return true;
        }
        catch (e) {
            console.warn('localStorage 删除失败:', e);
            return false;
        }
    }
    clear() {
        if (this.isIncognito) {
            console.log('无痕模式检测到，跳过 localStorage 清空');
            return false;
        }
        try {
            localStorage.clear();
            return true;
        }
        catch (e) {
            console.warn('localStorage 清空失败:', e);
            return false;
        }
    }
}
// 创建全局实例
export const safeStorage = new SafeStorage();
